import TooltipIcon from '../../../assets/tooltip-icon.svg';
import { Image } from 'react-bootstrap';
import { DynamicImage, RoundButton } from '@components';
import { tiersArticleUrl } from '@constants';
import { usePlatformSettings } from '@hooks/usePlatformSettings';
import { numberToCurrency } from '@utils/balanceFormatter';

export const FPRequirementsTooltip = () => {

  return (
    <div className="tooltip__inner">
      <h5 className='tooltip__title'>
        <Image src={TooltipIcon} />
        <span>FLAME Power</span>
      </h5>
      <div className='tooltip__content'>
        <p>
          FLAME Power is an aggregator that counts
          all eligible FLAME balances across several sources.
        </p>
        <RoundButton
          className="tooltip__button"
          href={tiersArticleUrl}
          color="DARK"
          size="large"
        >
          Read more
        </RoundButton>
      </div>
    </div>
  )
}

export const CooldownPeriodTooltip = () => {

  return (
    <div className="tooltip__inner">
      <h5 className='tooltip__title'>
        <Image src={TooltipIcon} />
        <span>Cooldown period</span>
      </h5>
      <div className='tooltip__content'>
        <p>
          Cooldown period is a 7 days period after an IMO, during which wallets that have successfully invested in IDO,
          are restricted from applying to other IDOs whitelists.
        </p>
        <p>
          <b>Note</b>: It’s impossible to unstake and unlock your FLAME tokens during the 7 days of the Cooldown period.
        </p>
        <RoundButton
          className="tooltip__button"
          href={tiersArticleUrl}
          color="DARK"
          size="large"
        >
          Read more
        </RoundButton>
      </div>
    </div>
  )
}

export const SurpriseLotteryTooltip = () => {

  return (
    <div className="tooltip__inner">
      <h5 className='tooltip__title'>
        <Image src={TooltipIcon} />
        <span>Surprise Lottery </span>
      </h5>
      <div className='tooltip__content'>
        <p>
          We will randomly pick 10 lucky winners of the Light Tier and airdrop them an IDO launch prize.
        </p>
      </div>
    </div>
  )
}

export const FCFSLotteryTooltip = () => {
  const { settings } = usePlatformSettings()

  return (
    <div className="tooltip__inner">
      <h5 className='tooltip__title'>
        <Image src={TooltipIcon} />
        <span>FCFS Whitelist Lottery</span>
      </h5>
      <div className='tooltip__content'>
        <p>
          The more FLAME Power you have, the higher your allocation and chance to win a spot in a whitelist.
        </p>
        <p>
          Participation in IDOs is on a FCFS basis.
        </p>
        <div className='tooltip__widget'>
          <div className='d-flex align-items-center tooltip__expression'>
            <DynamicImage path="tiers/flame.svg" />
            <b>=</b>
            <DynamicImage path="tiers/ticket-single.svg" />
          </div>
          <div className='purple-text'>
            Every {numberToCurrency(settings!.flamePowerCost!.LOTTERY_TICKET_PRICE!)} FLAME power <br/>
            = 1 Lottery ticket
          </div>
        </div>
        <RoundButton
          className="tooltip__button"
          href={tiersArticleUrl}
          color="DARK"
          size="large"
        >
          Read more
        </RoundButton>
      </div>
    </div>
  )
}

export const GuaranteedAllocationTooltip = () => {

  return (
    <div className="tooltip__inner">
      <h5 className='tooltip__title'>
        <Image src={TooltipIcon} />
        <span>Guaranteed Allocation</span>
      </h5>
      <div className='tooltip__content'>
        <p>
          Top 100 on FLAME Leaderboard and Hiro holders are qualified for Guaranteed Allocation. The amount depends on
          their Tier.
        </p>
      </div>
    </div>
  )
}
